function _objectSpread(e) { for (var r = 1; r < arguments.length; r++) { var t = null != arguments[r] ? Object(arguments[r]) : {}, o = Object.keys(t); "function" == typeof Object.getOwnPropertySymbols && o.push.apply(o, Object.getOwnPropertySymbols(t).filter(function (e) { return Object.getOwnPropertyDescriptor(t, e).enumerable; })), o.forEach(function (r) { _defineProperty(e, r, t[r]); }); } return e; }
function _defineProperty(e, r, t) { return (r = _toPropertyKey(r)) in e ? Object.defineProperty(e, r, { value: t, enumerable: !0, configurable: !0, writable: !0 }) : e[r] = t, e; }
function _toPropertyKey(t) { var i = _toPrimitive(t, "string"); return "symbol" == typeof i ? i : i + ""; }
function _toPrimitive(t, r) { if ("object" != typeof t || !t) return t; var e = t[Symbol.toPrimitive]; if (void 0 !== e) { var i = e.call(t, r || "default"); if ("object" != typeof i) return i; throw new TypeError("@@toPrimitive must return a primitive value."); } return ("string" === r ? String : Number)(t); }
function _slicedToArray(r, e) { return _arrayWithHoles(r) || _iterableToArrayLimit(r, e) || _unsupportedIterableToArray(r, e) || _nonIterableRest(); }
function _nonIterableRest() { throw new TypeError("Invalid attempt to destructure non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method."); }
function _unsupportedIterableToArray(r, a) { if (r) { if ("string" == typeof r) return _arrayLikeToArray(r, a); var t = {}.toString.call(r).slice(8, -1); return "Object" === t && r.constructor && (t = r.constructor.name), "Map" === t || "Set" === t ? Array.from(r) : "Arguments" === t || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(t) ? _arrayLikeToArray(r, a) : void 0; } }
function _arrayLikeToArray(r, a) { (null == a || a > r.length) && (a = r.length); for (var e = 0, n = Array(a); e < a; e++) n[e] = r[e]; return n; }
function _iterableToArrayLimit(r, l) { var t = null == r ? null : "undefined" != typeof Symbol && r[Symbol.iterator] || r["@@iterator"]; if (null != t) { var e, n, i, u, a = [], f = !0, o = !1; try { if (i = (t = t.call(r)).next, 0 === l) { if (Object(t) !== t) return; f = !1; } else for (; !(f = (e = i.call(t)).done) && (a.push(e.value), a.length !== l); f = !0); } catch (r) { o = !0, n = r; } finally { try { if (!f && null != t.return && (u = t.return(), Object(u) !== u)) return; } finally { if (o) throw n; } } return a; } }
function _arrayWithHoles(r) { if (Array.isArray(r)) return r; }
import React, { useCallback, useContext, useMemo, useState } from 'react';
import CompareContext from '../RecordCompareContext';
import stripHtml from '../../../../utils/stripHtml';
import filterLayoutToVisibleFromSchema from '../../../util/recordCompareFilterLayoutToVisibleFromSchema';
import { injectIntl } from 'react-intl';
import PropertyTitle from '../RecordComparePropertyTitle';
import { Column, Row } from '../../Layout/RecordCompareLayout';
import RecordCompareStateContext from '../../../RecordCompareStateContext';
import CheckboxField from './CheckboxField';
import getOr from '../../../../utils/getOr';
import I18n from '../../../../I18n/I18n/I18n';
import styles from './RecordCompareArrayCard.module.scss';
import { WmButton } from '@watermarkinsights/ripple-react';
function getChildRecord(record, layoutRowId) {
  var uiSchema = record.uiSchema[layoutRowId].items;
  var schema = record.schema.properties[layoutRowId].items;
  var data = record.data[layoutRowId] || [];
  return Object.assign({}, record, {
    uiSchema: uiSchema,
    schema: schema,
    data: data,
    layout: filterLayoutToVisibleFromSchema(uiSchema['dm:layout'], schema)
  });
}
var TAB = 'Tab';
var ARROW_UP = 'ArrowUp';
var ARROW_LEFT = 'ArrowLeft';
var ARROW_RIGHT = 'ArrowRight';
var ARROW_DOWN = 'ArrowDown';
function BaseCardContainer(_ref) {
  var intl = _ref.intl,
    record = _ref.record,
    layoutRowId = _ref.layoutRowId,
    recordIndex = _ref.recordIndex,
    rows = _ref.rows,
    childRecords = _ref.childRecords,
    children = _ref.children;
  var _useContext = useContext(CompareContext),
    mergeRecord = _useContext.mergeRecord,
    propertyPrefix = _useContext.propertyPrefix,
    records = _useContext.records;
  var _useContext2 = useContext(RecordCompareStateContext),
    mergeSelections = _useContext2.mergeSelections,
    selections = _useContext2.selections,
    showErrors = _useContext2.showErrors;
  var _useState = useState(-2),
    _useState2 = _slicedToArray(_useState, 2),
    focusState = _useState2[0],
    setFocusState = _useState2[1];
  var uiSchema = mergeRecord.uiSchema;
  var propertySelections = selections[layoutRowId];
  var anyRowHasData = useCallback(function (index) {
    return rows.reduce(function (acc, row, rowIndex) {
      return acc || row[index].hasData;
    }, false);
  }, [rows]);
  var allChecked = useCallback(function (recordIndex) {
    var result = true;
    var selectionId = propertyPrefix + layoutRowId;
    var rowSelection = selections[selectionId];
    if (!rowSelection && rows && rows.length > 0) {
      for (var j = 0; j < rows.length; j++) {
        if (rows[j][recordIndex].hasData) {
          result = false;
          break;
        }
      }
    }
    for (var i = 0; rowSelection && i < rows.length; i++) {
      if (rows.length > 0 && rows[i][recordIndex].hasData && rowSelection && !rowSelection["r".concat(i, "-c").concat(recordIndex)]) {
        result = false;
        break;
      }
    }
    return result;
  }, [rows, selections, propertyPrefix, layoutRowId]);
  var anyChecked = useCallback(function () {
    var result = false;
    for (var i = 0; !result && i < childRecords.length; i++) {
      var _recordIndex = i;
      var selectionId = propertyPrefix + layoutRowId;
      var rowSelection = selections[selectionId];
      if (!rowSelection && rows && rows.length > 0) {
        for (var j = 0; j < rows.length; j++) {
          if (rows[j][_recordIndex].hasData) {
            result = false;
            break;
          }
        }
      }
      for (var _i = 0; rowSelection && _i < rows.length; _i++) {
        if (rows.length > 0 && rows[_i][_recordIndex].hasData && rowSelection && rowSelection["r".concat(_i, "-c").concat(_recordIndex)]) {
          result = true;
          break;
        }
      }
    }
    return result;
  }, [rows, selections, propertyPrefix, layoutRowId, childRecords]);
  var handleSelectClick = useCallback(function (index) {
    var newSelections = rows.reduce(function (rowsAcc, row, rowIndex) {
      if (anyRowHasData(index)) {
        if (row[index].hasData) {
          rowsAcc["r".concat(rowIndex, "-c").concat(index)] = !allChecked(index);
        }
      } else {
        rowsAcc = Object.keys(propertySelections).reduce(function (selectionsAcc, key, keyIndex) {
          selectionsAcc[key] = !allChecked(index);
          return selectionsAcc;
        }, {});
      }
      return rowsAcc;
    }, {});
    mergeSelections(_defineProperty({}, layoutRowId, _objectSpread({}, propertySelections, newSelections)));
  }, [rows, mergeSelections, layoutRowId, propertySelections, anyRowHasData]);
  var description = useMemo(function () {
    var propUiSchema = uiSchema[layoutRowId];
    var getTitle = getOr({})('ui:title');
    var _getTitle = getTitle(propUiSchema),
      text = _getTitle.text;
    return text;
  }, [uiSchema]);
  var handleKeyDown = useCallback(function (event) {
    switch (event.key) {
      case TAB:
        setFocusState(-2);
        if (event.shiftKey) {
          var schemaKeys = Object.keys(uiSchema);
          var schemaIndex = schemaKeys.indexOf(layoutRowId);
          for (var i = schemaIndex - 1; i > 0; i--) {
            var testField = document.querySelector("input[id=\"".concat(records[0].recordId, "-").concat(schemaKeys[i], "-", 0, "\"]"));
            var testArray = document.querySelectorAll("#".concat(schemaKeys[i], "-").concat(recordIndex));
            if (testArray.length > 0) {
              event.preventDefault();
              testArray.item(0).focus();
              break;
            }
            if (testField !== null) {
              event.preventDefault();
              testField.focus();
              break;
            }
          }
        } else {
          var _schemaKeys = Object.keys(uiSchema);
          var _schemaIndex = _schemaKeys.indexOf(layoutRowId);
          for (var _i2 = _schemaIndex + 1; _schemaKeys && _i2 < _schemaKeys.length; _i2++) {
            var _testField = document.querySelector("input[id=\"".concat(records[0].recordId, "-").concat(_schemaKeys[_i2], "-", 0, "\"]"));
            var _testArray = document.querySelectorAll("#".concat(_schemaKeys[_i2], "-").concat(recordIndex));
            if (_testArray.length > 0) {
              event.preventDefault();
              _testArray.item(0).focus();
              break;
            }
            if (_testField !== null) {
              event.preventDefault();
              _testField.focus();
              break;
            }
          }
        }
        break;
      case ARROW_RIGHT:
        setFocusState(-2);
        var nextRecord = document.querySelectorAll("#".concat(layoutRowId, "-").concat(recordIndex + 1));
        if (nextRecord && nextRecord.length > 0) {
          nextRecord.item(0).focus();
        } else {
          document.querySelector("#".concat(layoutRowId, "-0")).focus();
        }
        break;
      case ARROW_DOWN:
        event.preventDefault();
        if (focusState < -1) {
          document.querySelector("#".concat(layoutRowId, "-").concat(record.recordId, "-").concat(recordIndex, "-all")).focus();
        } else {
          document.querySelector("#".concat(layoutRowId, "-").concat(record.recordId, "-").concat(recordIndex, "-").concat(focusState + 1)).focus();
        }
        setFocusState(focusState + 1);
        break;
      case ARROW_LEFT:
        setFocusState(-2);
        var previousRecords = document.querySelectorAll("span[id^=\"".concat(layoutRowId, "\"]"));
        if (recordIndex > 0) {
          previousRecords.item(recordIndex - 1).focus();
        } else {
          previousRecords.item(previousRecords ? previousRecords.length - 1 : 0).focus();
        }
        break;
      case ARROW_UP:
        event.preventDefault();
        if (focusState > 0) {
          document.querySelector("#".concat(layoutRowId, "-").concat(record.recordId, "-").concat(recordIndex, "-").concat(focusState - 1)).focus();
        } else {
          document.querySelector("#".concat(layoutRowId, "-").concat(record.recordId, "-").concat(recordIndex, "-all")).focus();
        }
        setFocusState(focusState - 1);
        break;
      default:
        break;
    }
  }, [focusState, record, uiSchema]);
  return /*#__PURE__*/React.createElement("span", {
    id: "".concat(layoutRowId, "-").concat(recordIndex),
    tabIndex: 0,
    className: styles.cardContainer,
    onKeyDown: handleKeyDown
  }, /*#__PURE__*/React.createElement(PropertyTitle, {
    property: layoutRowId,
    recordIndex: recordIndex,
    readOnly: true,
    required: layoutRowId === 'intellcont_auth',
    error: layoutRowId === 'intellcont_auth' && showErrors && !anyChecked()
  }), anyRowHasData(recordIndex) ? /*#__PURE__*/React.createElement("div", {
    className: styles.selectAll
  }, /*#__PURE__*/React.createElement(WmButton, {
    id: "".concat(layoutRowId, "-").concat(record.recordId, "-").concat(recordIndex, "-all"),
    buttonType: "textonly",
    onClick: function onClick() {
      handleSelectClick(recordIndex);
    },
    labelForIdenticalButtons: intl.formatMessage({
      id: allChecked(recordIndex) ? '@dm/components.record-compare.labels.unselect-all-aria' : '@dm/components.record-compare.labels.select-all-aria'
    }, {
      fieldLabel: stripHtml(description),
      recordLabel: record.title ? record.title : intl.formatMessage({
        id: '@dm/components.record-compare.labels.record-header'
      }, {
        index: recordIndex
      })
    })
  }, /*#__PURE__*/React.createElement(I18n, {
    i18n: intl.formatMessage({
      id: allChecked(recordIndex) ? '@dm/components.record-compare.labels.unselect-all-array' : '@dm/components.record-compare.labels.select-all-array'
    }, {
      count: record.data.length
    })
  }))) : null, children, layoutRowId === 'intellcont_auth' && showErrors && !anyChecked() ? /*#__PURE__*/React.createElement("div", {
    id: "".concat(layoutRowId, "-").concat(recordIndex, "-error"),
    className: styles.error,
    "aria-atomic": true,
    "aria-live": 'polite'
  }, /*#__PURE__*/React.createElement(I18n, {
    i18n: intl.formatMessage({
      id: '@dm/components.record-compare.labels.error-author'
    })
  })) : null);
}
var CardContainer = injectIntl(BaseCardContainer);
function ArrayCard(_ref2) {
  var layoutRowId = _ref2.layoutRowId,
    intl = _ref2.intl;
  var _useContext3 = useContext(CompareContext),
    mergeRecord = _useContext3.mergeRecord,
    records = _useContext3.records,
    propertyPrefix = _useContext3.propertyPrefix;
  var _useContext4 = useContext(RecordCompareStateContext),
    isMergeEnabled = _useContext4.isMergeEnabled,
    selections = _useContext4.selections;
  var childRecords = useMemo(function () {
    return records.map(function (record) {
      return getChildRecord(record, layoutRowId);
    });
  }, [records, layoutRowId]);
  var rows = useMemo(function () {
    var size = childRecords ? childRecords.reduce(function (acc, record) {
      return Math.max(acc, record.data.length);
    }, 1) : 0;
    var result = [];
    var _loop = function _loop(index) {
      result.push(childRecords.map(function (childRecord) {
        return Object.assign({}, childRecord, {
          hasData: index < childRecord.data.length,
          data: childRecord.data[index] || {}
        });
      }));
    };
    for (var index = 0; index < size; index++) {
      _loop(index);
    }
    return result;
  }, [childRecords]);
  var anyRowHasData = useCallback(function (index) {
    return rows.reduce(function (acc, row, rowIndex) {
      return acc || row[index].hasData;
    }, false);
  }, [rows]);
  var checked = useCallback(function (index) {
    var selectionId = propertyPrefix + layoutRowId;
    var rowSelection = selections[selectionId];
    var checkedValue = false;
    if (selections && rows) {
      checkedValue = rows.reduce(function (acc, row, rowIndex) {
        if (rowSelection) {
          if (anyRowHasData(index)) {
            if (row[index].hasData) {
              return acc || !!rowSelection["r".concat(rowIndex, "-c").concat(index)];
            }
          } else {
            var anySelected = Object.keys(rowSelection).reduce(function (selectionAcc, key, keyIndex) {
              return selectionAcc || rowSelection[key];
            }, false);
            return acc || !anySelected;
          }
        }
        return acc;
      }, false);
    }
    return checkedValue;
  }, [propertyPrefix, layoutRowId, selections, rows, anyRowHasData]);
  var description = useMemo(function () {
    var uiSchema = mergeRecord.uiSchema;
    var propUiSchema = uiSchema[layoutRowId];
    var getTitle = getOr({})('ui:title');
    var _getTitle2 = getTitle(propUiSchema),
      text = _getTitle2.text;
    return text;
  }, [mergeRecord]);
  var emptyLabel = useMemo(function () {
    return '[' + stripHtml(description) + ']';
  }, [description]);
  var recordsList = useMemo(function () {
    if (!childRecords || childRecords.length === 0) {
      return null;
    }
    return childRecords.map(function (record, recordIndex) {
      return /*#__PURE__*/React.createElement(Column, {
        highlight: isMergeEnabled && checked(recordIndex)
      }, /*#__PURE__*/React.createElement(CardContainer, {
        record: record,
        rows: rows,
        layoutRowId: layoutRowId,
        recordIndex: recordIndex,
        childRecords: childRecords
      }, /*#__PURE__*/React.createElement("div", {
        className: styles.checkboxContainer
      }, record.data.map(function (data, dataIndex) {
        return /*#__PURE__*/React.createElement(CheckboxField, {
          data: data,
          layoutRowId: layoutRowId,
          recordIndex: recordIndex,
          fieldIndex: dataIndex,
          key: "".concat(layoutRowId, "-").concat(recordIndex, "-").concat(dataIndex)
        });
      }), record.data && record.data.length === 0 && intl.formatMessage({
        id: '@dm/components.record-compare.labels.empty-card-group'
      }, {
        label: emptyLabel
      }))));
    });
  }, [checked, childRecords, intl, isMergeEnabled, layoutRowId, mergeRecord]);
  return /*#__PURE__*/React.createElement(Row, null, recordsList);
}
export default injectIntl(ArrayCard);